<template>
  <div class="ml-3">
    <button
      v-if="results?.length > 0"
      class="btn btn-green-border export-button"
      @click="getVisitDetail()"
    >
      <i class="fas fa-file-download text-green" />
      Descargar Reporte
    </button>
    <div v-if="results.length > 0" class="ml-2 mb-2 pt-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Detalles de Visitas</strong>
    </div>
    <custom-result-not-found v-if="results.length === 0" />
    <template v-else>
      <div>
        <div class="row mx-0 border-bottom rounded pb-3 pl-3 pr-4 mb-2">
          <div class="col-8 col-sm col-12">
            <span class="fw-bold font-14">Leyenda:</span>
            <div class="legend-container d-flex align-items-center">
              <span class="legend-item">TL = Tipo de Lugar de Servicio |</span>
              <span class="legend-item">E = Escuela,</span>
              <span class="legend-item">OP = Oficina de Proveedor,</span>
              <span class="legend-item">H = Hogar</span>
            </div>
          </div>
          <div
            class="col-4 col-sm col-12 mb-2 mb-md-0 d-flex justify-content-end align-items-center"
          >
            <br />
            <span class="d-block font-16 mr-2">Total:</span>
            <span class="fw-bold font-16">
              {{ visitGrandTotalCost | price }}
            </span>
          </div>
        </div>

        <div
          v-for="(row, idx) of results"
          :key="`visit-${idx}`"
          class="row mx-0 border-bottom rounded py-3 pl-3 pr-4 mb-2"
        >
          <div class="col-2 col-sm col-12 mb-2 mb-md-0">
            <span class="d-block">Fecha:</span>
            <span class="font-16">{{ row.date | date('DD/MM/YYYY') }}</span>
          </div>
          <div class="col-md-2 col-sm col-12 mb-2 mb-md-0">
            <span class="d-block">Horario:</span>
            <span class="font-16" v-html="formatedHour(row)" />
          </div>
          <div class="col-md-2 col-sm col-12 mb-3 mb-md-0">
            <span class="d-block">Tipo de Visita:</span>
            <span class="font-16">{{ row.visitType }}</span>
            <span v-if="row.repositionVisitDate" class="d-block font-14">
              Visita repuesta del {{ row.repositionVisitDate | date }}
            </span>
          </div>
          <div class="col-md-1 col-sm col-12 mb-3 mb-md-0">
            <span class="d-block">TL:</span>
            <span class="font-16">{{ row.locationTypeCode }}</span>
          </div>
          <div
            v-if="row.isAssistantService"
            class="col-2 col-sm col-12 mb-2 mb-md-0"
          >
            <span class="d-block">Tarifa Servicio:</span>
            <span class="font-16">{{ row.visitServiceCost | price }}</span>
          </div>
          <div
            v-if="row.isAssistantService"
            class="col-2 col-sm col-12 mb-2 mb-md-0"
          >
            <span class="d-block">Costo Transportación:</span>
            <span class="font-16">{{ row.transportationCost | price }}</span>
          </div>
          <div
            class="col-1 col-sm col-12 mb-2 mb-md-0 d-flex flex-column align-items-end"
          >
            <span class="d-block">Total:</span>
            <span class="font-16">{{ row.visitTotalCost | price }}</span>
          </div>
        </div>
      </div>

      <pagination
        v-if="pagination.totalItemCount > defaultPageSize"
        :data="pagination"
        show-text
        @pagination-go-page="goToPage"
      />
    </template>
  </div>
</template>

<script>
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import { getVisits as _getVisits } from '@/services/provider/billing-contract.api.js';
import moment from 'moment';
import ReportServices from '@/services/common/report.api';
import utils from '@/utils/utilities';

export default {
  name: 'VisitDetail',
  components: { Pagination, CustomResultNotFound },
  props: {
    item: {
      type: Object,
      default: () => 0,
    },
    defaultPageSize: {
      type: Number,
      default: () => 5,
    },
    ignoreMothFilter: {
      type: Boolean,
      default: () => false,
    },
    /** Este componente se utiliza desde dos lugares: pantalla de contratos y detalle de factura.
     * En el detalle de factura queremos filtrar las visitas por especialista (el detalle)
     * pero en el result row de contratos queremos ver todas las visitas sin discriminar el especialista.
     */
    ignoreSpecialistFilter: {
      type: Boolean,
      default: () => false,
    },
    academicYear: {
      type: Number,
      default: () => 0,
    },
    specialistId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
    },
    results: [],
  }),
  computed: {
    visitType() {
      return ({ visitCompensatory }) =>
        visitCompensatory ? 'Visita Regular' : 'Visita de Reposición';
    },
    formatedHour() {
      return ({ startTime, endTime, continuedStartTime, continuedEndTime }) => {
        let result = `${this.formatHour(startTime)} - ${this.formatHour(
          endTime
        )}`;

        if (continuedStartTime && continuedEndTime) {
          result =
            result +
            `</br> ${this.formatHour(continuedStartTime)} - ${this.formatHour(
              continuedEndTime
            )}`;
        }

        return result;
      };
    },
    visitGrandTotalCost() {
      return this.results[0].total;
    },
  },
  async created() {
    await this.goToPage(1);
  },
  methods: {
    formatHour(timespan) {
      return moment(timespan, 'HH:mm:ss', true).format('hh:mm A');
    },
    async getVisitDetail() {
      await ReportServices.getReport('reportcontractvisits', {
        academicYearId:
          this.academicYear == 0 ? this.item.academicYearId : this.academicYear,
        contractId: this.item.contractId,
      }).then((res) => utils.convertToBlob(res.data));
    },
    async goToPage(page) {
      this.pagination.currentPage = page;

      const getVisitPayLoad = {
        contractId: this.item.contractId,
        pageIndex: this.pagination.currentPage,
        pageSize: this.defaultPageSize,
        academicYearId:
          this.academicYear == 0 ? this.item.academicYearId : this.academicYear,
        monthNumber: this.item.monthNumber,
        ignoreMonthFilter: this.ignoreMothFilter,
      };

      if (!this.ignoreSpecialistFilter) {
        getVisitPayLoad.specialistId =
          this.specialistId == 0 ? this.item.specialistId : this.specialistId;
      }

      const { data } = await _getVisits(getVisitPayLoad);

      this.results = data.data;

      this.pagination = {
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
  },
};
</script>
<style scoped lang="scss">
.orange-icon {
  color: #ff7058;
}

.legend-container {
  display: flex;
  align-items: center;
  font-size: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.legend-item {
  margin-right: 8px;

  @media (max-width: 768px) {
    margin-right: 0;
    width: 100%;
  }
}

.export-button {
  width: 175px;
  float: right;
  margin-top: 2px;
  margin-right: 10px;
}
</style>
